import { DegreeCompletionBlock } from './degree_completion_block_builder';
import { DegreeCompletionBlockCourse } from './degree_completion_block_course_builder';
import { UnappliedCredits } from './unapplied_credits_builder';

export class DegreeCompletion {
  static ngDegreeCompletionBlockBuilder: typeof DegreeCompletionBlock;
  static ngDegreeCompletionBlockCourseBuilder: typeof DegreeCompletionBlockCourse;
  static ngUnappliedCreditsBuilder: typeof UnappliedCredits;
  static numberFilter: ng.IFilterNumber;

  id: number = 0;
  degree_completion_type: string = 'credit';
  degree_completion: number = 0;
  credits_required: number = 0;
  credits_applied: number = 0;
  additional_credits: number = 0;
  displayEarnedCredits: string = '0';
  displayAdditionalCredits: string = '0';
  displayRequiredCredits: string = '0';
  max_transfer_credits: number = 0;
  blocks: DegreeCompletionBlock[] = [];
  additional_courses: DegreeCompletionBlockCourse[] = [];
  unapplied_credits: UnappliedCredits;
  has_applied_credits: Boolean = false;

  constructor(degree_completion: DegreeCompletion) {
    _.merge(this, degree_completion);
    this.blocks = _.map(this.blocks, (block) => DegreeCompletion.ngDegreeCompletionBlockBuilder.build(block));
    this.additional_courses = _.map(this.additional_courses, (course) =>
      DegreeCompletion.ngDegreeCompletionBlockCourseBuilder.build(course)
    );
    this.unapplied_credits = DegreeCompletion.ngUnappliedCreditsBuilder.build(this.unapplied_credits);
    this.displayEarnedCredits = DegreeCompletion.numberFilter(DegreeCompletion.numberFilter(this.credits_applied, 2));
    this.displayAdditionalCredits = DegreeCompletion.numberFilter(
      DegreeCompletion.numberFilter(this.additional_credits, 2)
    );
    this.displayRequiredCredits = DegreeCompletion.numberFilter(
      DegreeCompletion.numberFilter(this.credits_required, 2)
    );
    this.has_applied_credits = DegreeCompletion.hasAppliedCredits(this);
  }

  static hasAppliedCredits(degreeCompletion: DegreeCompletion): boolean {
    if (!degreeCompletion) {
      return false;
    }
    if (!_.isEmpty(degreeCompletion.additional_courses)) {
      return true;
    }
    for (let block of degreeCompletion.blocks) {
      for (let requirement of block.requirements) {
        if (!_.isEmpty(requirement.transferred_classes)) {
          return true;
        }
      }
    }
    return false;
  }

  static build(degree_completion: any): DegreeCompletion {
    return new DegreeCompletion(degree_completion);
  }
}

angular
  .module('capability-ng-transfer')
  .factory(
    'ngDegreeCompletionBuilder',
    (
      ngDegreeCompletionBlockBuilder: typeof DegreeCompletionBlock,
      ngDegreeCompletionBlockCourseBuilder: typeof DegreeCompletionBlockCourse,
      ngUnappliedCreditsBuilder: typeof UnappliedCredits,
      numberFilter: ng.IFilterNumber
    ): typeof DegreeCompletion => {
      DegreeCompletion.numberFilter = numberFilter;
      DegreeCompletion.ngDegreeCompletionBlockBuilder = ngDegreeCompletionBlockBuilder;
      DegreeCompletion.ngDegreeCompletionBlockCourseBuilder = ngDegreeCompletionBlockCourseBuilder;
      DegreeCompletion.ngUnappliedCreditsBuilder = ngUnappliedCreditsBuilder;
      return DegreeCompletion;
    }
  );



// WEBPACK FOOTER //
// ./app/lib/transfer/builders/degree_completion_builder.ts